import { format } from "date-fns"
import { DateFormat } from "./date.types"

/**
 * Format a date by a given, pre-defined DateFormat.
 * @param date - A date string or Date object
 * @param dateFormat - A DateFormat enum value
 * @returns The formatted date string
 */
export const formatDate = (date: string | Date, dateFormat: DateFormat) =>
  format(new Date(date), dateFormat.toString())

/**
 * Format a date in UTC using Intl.DateTimeFormat options.
 * @param date - A date string or Date object
 * @param locale - BCP 47 locale tag (defaults to en-US)
 * @param options - Intl.DateTimeFormat options (defaults to numeric month/day/year)
 * @returns The formatted date string in UTC
 */
export const formatDateUtc = (
  date: string | Date,
  locale = "en-US",
  options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }
) =>
  new Intl.DateTimeFormat(locale, {
    ...options,
    timeZone: "UTC",
  }).format(new Date(date))
